export default {
  online_shop: 'Verkkokauppa',
  storefront: 'Storefront',
  reservations: 'Varaukset',
  import: 'Tuonti',
};
